<template>

  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">{{title}}</h3>
        </b-col>
        <b-col class="text-right">
          <a href="javascript:void(0)" class="btn btn-sm btn-primary" @click="viewAll">{{language_terms['VIEW_ALL']}}</a>
        </b-col>
      </b-row>
    </template>
        <loading :active.sync="loading" 
          color= '#007bff'
          :width= '128'
          :height= '128'
          loader='dots'
          :can-cancel="true" 
          :is-full-page="true">
        </loading>
        <el-table class="table-responsive table" :data="items" header-row-class-name="thead-light" @row-click="clickOnDetails">
        <el-table-column :label="language_terms['DOCUMENT']" sortable min-width="70px" prop="code">
            <template v-slot="{row}">
            <div class="font-weight-600">{{row.code}}</div>
            <div>{{row.date}}</div>
            </template>
        </el-table-column>
        <el-table-column :label="language_terms['CUSTOMER']" sortable min-width="70px" prop="contact_name">
        </el-table-column>
        <el-table-column :label="language_terms['SALESPERSON']" sortable min-width="70px" prop="salesperson_contact_name">
        </el-table-column>
        <!-- <el-table-column :label="language_terms['DATE']" sortable min-width="50px" prop="date">
        </el-table-column> -->
            <el-table-column :label="language_terms['DUE_DATE']" sortable min-width="55px" prop="due_date">
        </el-table-column>

        <el-table-column :label="language_terms['NETT_AMOUNT']" sortable  prop="nett_amount">
            <template v-slot="{row}">
            <div>{{row.currency_prefix}} {{row.nett_amount}}</div>
            </template>
        </el-table-column>

        <!-- <el-table-column label="Bounce rate"
                        sortable
                        min-width="90px"
                        prop="bounceRate">
            <template v-slot="{row}">
            <i class="fas fa-arrow-up text-success mr-3"
                :class="row.bounceRateDirection === 'up' ? 'text-success': 'text-danger'">
            </i>
            {{row.bounceRate}}
            </template>
        </el-table-column> -->
        </el-table>
  </b-card>
</template>
<script>
  import { mapState } from "vuex";

  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    name: 'page-visits-table',
    components: {
      Loading,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    computed: {
      ...mapState({
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge
        }),
    },
    props:{
        title: {
            type: String,
            default: "",
            description: "Card Title",
            required: true,
        },
        items: {
            type: Array,
            default: function () { return [] },
            description: "Table Items",
            required: true,
        },
        url: {
            type: String,
            default: "",
            description: "View All",
            required: true,
        },
    },
    data() {
      return {
          loading:false
      }
    },
    methods:
    {
        async clickOnDetails(row)
        {            
            this.loading = true
            await this.$router.push("/sales/sales-quotation/" + row.code)
            this.loading = false

        },
        async viewAll()
        {
            this.loading = true
            await this.$router.push(this.$props.url);
            this.loading = false
        }
    }
  }
</script>
<style>
</style>
